import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { getDidomiConfig } from './config'

function getDidomiScriptContent({
  apiKey,
  noticeId,
  countryCode,
}: {
  apiKey: string
  noticeId: string
  countryCode: MarketCountryCode
}) {
  return `window.didomiConfig = ${JSON.stringify(getDidomiConfig(countryCode))};

    (function(){(function(e,r){var t=document.createElement("link");t.rel="preconnect";t.as="script";var n=document.createElement("link");n.rel="dns-prefetch";n.as="script";var i=document.createElement("script");i.id="spcloader";i.type="text/javascript";i["async"]=true;i.charset="utf-8";var o="https://sdk.privacy-center.org/"+e+"/loader.js?target_type=notice&target="+r;if(window.didomiConfig&&window.didomiConfig.user){var a=window.didomiConfig.user;var c=a.country;var d=a.region;if(c){o=o+"&country="+c;if(d){o=o+"&region="+d}}}t.href="https://sdk.privacy-center.org/";n.href="https://sdk.privacy-center.org/";i.src=o;var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s);s.parentNode.insertBefore(n,s);s.parentNode.insertBefore(i,s)})("${apiKey}","${noticeId}")})();`
}

export function getDidomiScript({
  apiKey,
  noticeId,
  countryCode,
}: {
  apiKey: string
  noticeId: string
  countryCode: MarketCountryCode
}) {
  return `
  <script type="text/javascript">
    ${getDidomiScriptContent({ apiKey, noticeId, countryCode })}
    </script>`
}

export function createDidomiScriptElement({
  apiKey,
  noticeId,
  countryCode,
}: {
  apiKey: string
  noticeId: string
  countryCode: MarketCountryCode
}) {
  const innerHTML = getDidomiScriptContent({ apiKey, noticeId, countryCode })

  const scriptElement = document.createElement('script')
  // nosemgrep: javascript.browser.security.insecure-document-method.insecure-document-method
  scriptElement.innerHTML = innerHTML

  return scriptElement
}
